import { SendLeadAcquisitionPayload } from "../../types/hubspot";
import { HubspotModel } from "../models";
import { formatCPF } from "./formatCpf";
import { formatPhone } from "./formatPhone";

type Payload = {
  termos: boolean
  opt_in_email: boolean
  maior_de_18_anos: boolean
  id_franquia_api_cep: string
  pageName: string 
} & HubspotModel

export function getSendLeadAcquisitionPayload(data: Payload): SendLeadAcquisitionPayload {
  const url = new URL(window.location.href)
  const queryParams = url.searchParams
  const payload: SendLeadAcquisitionPayload = {
    email: data?.email ? data?.email : '',
    firstname: data?.firstname ? data?.firstname : '',
    lastname: data?.lastname ? data?.lastname : '',
    phone: data?.phone ? formatPhone(data?.phone) : '',
    cpf_chave: data?.cpf ? formatCPF(data?.cpf) : '',
    termos: data?.termos,
    opt_in_whatsapp: data?.opt_in_whatsapp ? data?.opt_in_whatsapp : false,
    opt_in_sms: data?.sms_optin ? data?.sms_optin : false,
    opt_in_email: data?.opt_in_email,
    maior_de_18_anos: data?.maior_de_18_anos,
    cep: data?.cep ? data?.cep : '',
    city: data?.cidade ? data?.cidade : '',
    bairro: data?.bairro ? data?.bairro : '',
    address: data?.rua ? data?.rua : '',
    uf: data?.estado ? data?.estado : '',
    erro_cep: "", // NO MOMENTO NÃO TEM ESSE DADO NESSE PROJETO
    id_franquia_api_cep: data?.id_franquia_api_cep,
    id_promotor_lead: data?.id_promotor_lead ? data?.id_promotor_lead : '',
    lead_refiliacao: false, // NO MOMENTO NÃO TEM ESSE DADO NESSE PROJETO
    codigo_da_indicacao: "", // NO MOMENTO NÃO TEM ESSE DADO NESSE PROJETO
    cpf_indicador: "", // NO MOMENTO NÃO TEM ESSE DADO NESSE PROJETO
    utm_campaign: queryParams.get("utm_campaign") ?? "",
    utm_source: queryParams.get("utm_source") ?? "",
    utm_medium: queryParams.get("utm_medium") ?? "",
    utm_content: queryParams.get("utm_content") ?? "",
    utm_term: queryParams.get("utm_term") ?? "",
    pageUri:  window.location.href,
    pageName: data?.pageName
  }

  return payload
}